module.exports = __webpack_public_path__ + "media/header.f6040d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/header.svg
// module id = 885
// module chunks = 0